<template>
      <div class="">
        <div class="d-flex justify-content-center align-items-center" style="height:100vh;">
            <div class="col-lg-4 col-md-8">
                <div class="card shadow-sm border-0">
                    <div class="card-body p-0 m-0" style="border-top: 3px solid #540D6E;">
                        <div class="body-card px-lg-4 px-3 py-5 text-center">

                            <p class="text-center mb-5">
                                <span class="fa fa-check-circle fa-4x" style="color: #32cd32;"></span>
                            </p>

                            <h5 class="font-weight-bold mb-4">Your contribution to this pool has been recorded.</h5>

                            <p class="mb-5">You can monitor contributions to this pool from your 
                                <span class="font-weight-bold">Vesicash MoneyPool Dashboard</span>
                            </p>

                            <a href="/mypools" class="btn btn-custom btn-block" style="line-height: 3.3em;">My Dashboard</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>